module.exports = __webpack_public_path__ + "static/img/6.4a0662e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/6.jpg
// module id = pvxq
// module chunks = 12